import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LorenTrimPipe} from './pipes/loren-trim.pipe';


@NgModule({
    declarations: [
        LorenTrimPipe,
    ],
    exports: [
        LorenTrimPipe
    ],
    imports: [
        CommonModule
    ]
})
export class LorenTrimModule {
}
